import { asImages } from '@lss/common/src/shell/Image';
import ImageClass from "../../src/shell/Image";
import { TimageINT } from '../../src/store/slices/gameObjectSlice';
import { parseRequire } from "../../src/utils/parseImageUrl";

export const alexProfilesPic = asImages({
    alexInstaPortrait1: { url: parseRequire(require('@lss/common/game/assets/images/Instagram/Phone/alexInstaPortrait1.webp')) },
    alexInstaPortrait2: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Phone/alexInstaPortrait2.webp`)) },
    alexInstaPortrait3: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Phone/alexInstaPortrait3.webp`)) },
});
export const alexOtherPics = asImages({
    Alex_ee1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex_ee1.webp`)) },
    Alex_ee2: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex_ee2.webp`)) },
    Alex14_2: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex14_2.webp`)) },
});

export const alexImages = asImages({
    Alex1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex1.webp`)) },
    Alex2: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex2.webp`)) },
    Alex3: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex3.webp`)) },
    Alex4: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex4.webp`)) },
    Alex5: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex5.webp`)) },
    Alex6: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex6.webp`)) },
    Alex7: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex7.webp`)) },
    Alex8: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex8.webp`)) },
    Alex9: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex9.webp`)) },
    Alex10: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex10.webp`)) },
    Alex11: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex11.webp`)) },
    Alex12: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex12.webp`)) },
    Alex13: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex13.webp`)) },
    Alex14: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex14.webp`)) },
    Alex15: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex15.webp`)) },
    Alex16: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex16.webp`)) },
    Alex17: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex17.webp`)) },
    Alex18: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex18.webp`)) },
    Alex19: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex19.webp`)) },
    Alex20: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex20.webp`)) },
    Alex21: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex21.webp`)) },
    Alex22: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex22.webp`)) },
    Alex23: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex23.webp`)) },
    Alex24: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex24.webp`)) },
    Alex25: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex25.webp`)) },
    Alex26: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex26.webp`)),
        partials: {
            Alex26_1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex26_1.webp`)) },
        }
    },
    Alex27: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex27.webp`)) },
    Alex28: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex28.webp`)) },
    Alex29: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex29.webp`)),
        partials: {

            Alex29_1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex29_1.webp`)) },
        }
    },
    Alex30: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex30.webp`)),
        partials: {

            Alex30_1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex30_1.webp`)) },
        }
    },
    Alex31: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex31.webp`)) },
    Alex32: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex32.webp`)) },

    Alex33: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex33.webp`)) },
    Alex34: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex34.webp`)) },
    Alex35: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex35.webp`)) },
    Alex36: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex36.webp`)) },
    Alex37: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex37.webp`)) },
    Alex38: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex38.webp`)),
        partials: {
            Alex38_1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex38_1.webp`)) },
            Alex38_2: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex38_2.webp`)) },
            Alex38_3: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex38_3.webp`)) },

        }
    },
    Alex39: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex39.webp`)),
        partials: {
            Alex39_1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex39_1.webp`)) },

        }
    },
    Alex40: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex40.webp`)) },
    Alex41: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex41.webp`)),
        partials: {
            Alex41_1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex41_1.webp`)) },

        }
    },
    Alex42: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex42.webp`)) },
    Alex43: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex43.webp`)) },
    Alex44: {
        url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex44.webp`)),
        partials: {
            Alex44_1: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex44_1.webp`)) },

        }
    },
    Alex45: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex45.webp`)) },
    Alex46: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex46.webp`)) },
    Alex47: { url: parseRequire(require(`@lss/common/game/assets/images/Instagram/Alex/Alex47.webp`)) },
});
